import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal } from 'antd'
import AuditEnterpriseEntry from '../enterpriseEntry/audit'

const EnterpriseEntryDetail = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [applicationDetail, setApplicationDetail] = useState({})
  const [propsData, setPropsData] = useState({})
  const [isAuditVisible, setIsAuditVisible] = useState(false)

  const getEnterpriseEntryDetail = () => {
    axios.post('/p/enterprise_entry/application/detail/get', {
      merchant_oid: merchantOid,
      application_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setApplicationDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getEnterpriseEntryDetail()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, props.data.oid])

  const handleCancel = () => {
    props.isCancel()
  }

  const getColor = () => {
    if (applicationDetail.audit_status.key === 2) return 'green'
    if (applicationDetail.audit_status.key === 3) return 'red'
    return 'black'
  }

  const openAudit = () => {
    setIsAuditVisible(true)
    setPropsData({ 
      oid: applicationDetail.oid,
      auditStatus: applicationDetail.audit_status.key,
      failureReason: applicationDetail.failure_reason
    })
  }

  return (
    <Modal 
      title="企业入驻申请详情"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>
      
      <div className='public-datail-container'>
        <div className='public-datail-item'>
          <div className='public-datail-label'>申请时间</div>
          <div className='public-datail-content'>{applicationDetail.create_time}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>企业名称</div>
          <div className='public-datail-content'>{applicationDetail.company_name}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>所在区域</div>
          <div className='public-datail-content'>{applicationDetail.region}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>所属行业</div>
          <div className='public-datail-content'>{applicationDetail.industry}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>公司性质</div>
          <div className='public-datail-content'>{applicationDetail.company_type}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>公司规模</div>
          <div className='public-datail-content'>{applicationDetail.company_size}</div>
        </div>

        {applicationDetail.others && applicationDetail.others.map((item, index) => (
          <div className='public-datail-item' key={index}>
            <div className='public-datail-label'>{item.key}</div>
            <div className='public-datail-content'>
              {Array.isArray(item.value) && item.value.length > 0 ? (
                item.value.join(' ｜ ')
              ) : 
              (typeof item.value === 'string' && item.value.startsWith('https://oss.yunzhaosoft.com')) ? (
                <img src={item.value} alt={item.key} style={{ maxWidth: '200px', border: '1px solid #eee' }} />
              ) : (
                item.value
              )}
            </div>
          </div>
        ))}

        {applicationDetail.audit_status && 
          <div className='public-datail-item'>
            <div className='public-datail-label'>审核状态</div>
            <div style={{ color: getColor() }} className='public-datail-status'>{applicationDetail.audit_status.value}</div>
            <div className='public-datail-button' onClick={openAudit}>审核</div>
          </div>
        }
        {(applicationDetail.audit_status && applicationDetail.audit_status.key !== 1) && <>
          <div className='public-datail-item'>
            <div className='public-datail-label'>审核人</div>
            <div className='public-datail-content'>{applicationDetail.audit_person}</div>
          </div>
          <div className='public-datail-item'>
            <div className='public-datail-label'>审核时间</div>
            <div className='public-datail-content'>{applicationDetail.audit_time}</div>
          </div>
          <div className='public-datail-item'>
            <div className='public-datail-label'>审核备注</div>
            <div className='public-datail-content'>{applicationDetail.audit_remark}</div>
          </div>
        </>}
      </div>

      {isAuditVisible && <AuditEnterpriseEntry
        data={propsData}
        getEnterpriseEntryDetail={getEnterpriseEntryDetail}
        getApplicationData={() => { props.getApplicationData() }}
        isOpen={isAuditVisible}
        isCancel={() => { setIsAuditVisible(false) }}
      />}
    </Modal>
  )
}

export default EnterpriseEntryDetail
